import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class Error500Service {
  private showModalSubject = new BehaviorSubject<boolean>(false);
  showModal$ = this.showModalSubject.asObservable();

  constructor(private router: Router) {}

  showError500Modal() {
    this.showModalSubject.next(true);
  }

  hideError500Modal() {
    this.showModalSubject.next(false);
  }

  redirectToContactos() {
    this.router.navigate(['/inicio/contactos']);
    this.showModalSubject.next(false);
  }
}
